<template>
  <el-dialog :title="dialogTitle" :visible.sync="localVisible" center destroy-on-close width="60%">
    <el-table v-loading="loading" element-loading-spinner="atom-audit-loader" :data="displayRows" empty-text="No notification history for this coder." stripe max-height="350">
      <el-table-column prop="sentByUserName" label="Sent By" sortable>
        <template slot-scope="scope">
          <div>{{ scope.row.sentByUserName || '[not specified]' }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="sentDateUtc" label="Sent Date" sortable>
        <template slot-scope="scope">
          <div>{{ formatSentDate(scope.row.sentDateUtc) }}</div>
        </template>
      </el-table-column>
      <el-table-column label="Since Previous">
        <template slot-scope="scope">
          <div>{{ scope.row.sincePrevious }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="notificationStatus" label="Status" sortable>
        <template slot-scope="scope">
          <div>{{ scope.row.notificationStatus }}</div>
        </template>
      </el-table-column>
    </el-table>
    <span slot="footer">
      <el-button @click="localVisible = false" size="mini" plain round>Close</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import { formatDistanceStrict, isDate, parseISO } from 'date-fns'

  import dateHelper from '@/mixins/date-helper'

  export default {
    name: 'RebuttalNotificationHistoryDialog',
    mixins: [dateHelper],
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      coderName: {
        type: String,
        default: ''
      },
      historyRows: {
        type: Array,
        default: () => []
      },
      loading: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      localVisible: {
        get() {
          return this.visible
        },
        set(value) {
          this.$emit('update:visible', value)
        }
      },
      dialogTitle() {
        if (this.coderName) {
          return `Notification history - ${this.coderName}`
        }
        return 'Notification history'
      },

      displayRows() {
        const rows = this.historyRows.map((row) => ({ ...row }))

        if (rows.length === 0) {
          return rows
        }

        const chronological = [...rows].sort((a, b) => this.parseSentDate(a.sentDateUtc) - this.parseSentDate(b.sentDateUtc))
        const durationById = new Map()

        chronological.forEach((row, index) => {
          if (index === 0) {
            durationById.set(row.notificationHistoryId, 'Original')
            return
          }

          const current = this.parseSentDate(row.sentDateUtc)
          const previous = this.parseSentDate(chronological[index - 1].sentDateUtc)

          durationById.set(row.notificationHistoryId, current && previous ? formatDistanceStrict(current, previous) : '')
        })

        return rows.map((row) => ({
          ...row,
          sincePrevious: durationById.get(row.notificationHistoryId) || ''
        }))
      }
    },
    methods: {
      parseSentDate(value) {
        if (!value) {
          return null
        }

        if (isDate(value)) {
          return value
        }

        return parseISO(value)
      },

      formatSentDate(value) {
        if (!value) {
          return ''
        }
        return this.formatDateTime(value)
      }
    }
  }
</script>
